module.exports = __webpack_public_path__ + "static/media/icon_attachment.b191ec37.svg";